(function () {
  'use strict';
  var root = document.querySelector('[data-search]');
  if (!root) return;
  var input = root.querySelector('[data-search-input]');
  var panel = root.querySelector('[data-search-panel]');
  var list = root.querySelector('[data-search-results]');
  var status = root.querySelector('[data-search-status]');
  var all = root.querySelector('[data-search-all]');
  var quick = root.querySelector('[data-search-quick]');
  var timer = null, ctrl = null, lastQ = '';

  // "12 x 24", 12" x 24" and 12*24 all become 12x24, which matches the way sizes are titled and tagged
  function norm(q) {
    return q.replace(/(\d+(?:\.\d+)?)["'\u201D\u2033]*\s*[x\u00D7*]\s*(\d+(?:\.\d+)?)["'\u201D\u2033]*/gi, '$1x$2').replace(/\s+/g, ' ').trim();
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function open() {
    root.hidden = false;
    document.documentElement.classList.add('has-search');
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('has-search');
    if (ctrl) ctrl.abort();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-open]');
    if (t) { e.preventDefault(); root.hidden ? open() : close(); return; }
    if (e.target.closest('[data-search-close]')) { close(); return; }
    if (!root.hidden && !e.target.closest('[data-search]') && !e.target.closest('[data-search-open]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  function render(products, q) {
    list.innerHTML = '';
    if (!products.length) {
      status.textContent = 'No products found for "' + q + '". Try a brand, size or SKU, or ask for a free estimate.';
      all.hidden = true;
      panel.hidden = false;
      return;
    }
    status.textContent = 'Products for "' + q + '"';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      var li = document.createElement('li');
      li.innerHTML =
        '<a class="nx-search__item" href="' + esc(p.url) + '">' +
          '<span class="nx-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</span>' +
          '<span class="nx-search__vendor mono">' + esc(p.vendor) + '</span>' +
          '<span class="nx-search__name">' + esc(p.title) + '</span>' +
          '<span class="nx-search__price">' + money(p.price) + ' <small>/ box</small></span>' +
        '</a>';
      list.appendChild(li);
    });
    all.href = '/search?type=product&q=' + encodeURIComponent(norm(q));
    all.hidden = false;
    panel.hidden = false;
  }

  function run(q) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(norm(q)) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,tag,variants.sku,variants.title';
    status.textContent = 'Searching...';
    panel.hidden = false;
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (q !== lastQ) return;
        render((d.resources && d.resources.results && d.resources.results.products) || [], q);
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; status.textContent = 'Search is unavailable right now. Press Search to try again.'; });
  }

  root.querySelector('form').addEventListener('submit', function () { input.value = norm(input.value); });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.nx-search__item'));
    if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    e.preventDefault();
    if (e.key === 'ArrowDown') items[Math.min(i + 1, items.length - 1)].focus();
    else if (i <= 0) input.focus();
    else items[i - 1].focus();
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    lastQ = q;
    if (q.length < 2) { panel.hidden = true; quick.hidden = false; return; }
    quick.hidden = true;
    timer = setTimeout(function () { run(q); }, 180);
  });
})();
